function Signature() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1in'
      height='0.5in'
      viewBox='0 0 800 600'
    >
      <path
        id='signature'
        fill='none'
        stroke='#64ffda'
        stroke-width='15'
        d='M 131.21,79.52
           C 129.88,79.53 128.55,79.54 128.53,77.78
             128.52,76.03 128.51,74.27 128.50,72.51
             128.49,70.76 128.48,69.00 128.47,67.24
             128.43,61.97 127.35,60.11 128.37,51.43
             129.01,45.94 132.59,41.36 136.28,37.32
             137.73,35.74 141.31,31.57 142.91,30.25
             146.48,27.31 148.34,29.13 149.56,28.45
             151.30,27.49 152.22,26.68 153.56,26.67
             154.89,26.66 157.56,26.65 158.89,26.64
             160.23,26.63 161.95,27.13 162.90,28.37
             163.86,29.60 163.54,31.34 164.27,33.63
             164.79,35.25 165.12,37.27 165.64,38.89
             166.38,41.18 166.69,42.45 167.01,44.16
             167.72,47.97 168.39,51.17 168.40,52.93
             168.42,56.45 170.42,59.64 171.13,63.46
             171.45,65.16 171.81,68.41 172.52,72.23
             173.47,77.36 173.22,79.04 173.93,84.52
             174.38,87.99 173.98,91.55 174.00,95.06
             174.04,102.09 174.08,107.36 174.09,109.12
             174.13,116.15 174.18,123.18 174.21,128.45
             174.23,131.96 174.28,138.99 174.32,146.02
             174.37,153.04 173.06,156.57 173.10,163.59
             173.16,172.38 172.66,175.96 171.90,184.69
             171.28,191.88 169.32,198.76 169.36,204.03
             169.42,214.57 169.67,221.83 168.19,230.39
             167.53,234.22 166.27,242.57 165.66,251.49
             165.05,260.24 165.86,263.82 164.47,274.34
             163.30,283.16 161.91,291.93 161.94,297.20
             162.01,307.74 161.00,316.55 160.76,320.05
             160.14,328.97 158.86,335.74 158.24,344.66
             158.00,348.16 158.14,353.38 157.00,358.72
             155.51,365.69 156.33,367.61 155.74,371.03
             155.08,374.86 155.39,376.82 154.45,378.07
             153.52,379.32 153.11,376.32 153.10,374.56
             153.09,372.81 153.08,371.05 153.06,369.29
             153.05,367.53 153.04,365.78 153.03,364.02
             153.02,362.26 153.01,360.51 153.00,358.75
             152.99,356.99 152.97,355.24 152.96,353.48
             152.95,351.72 154.29,351.71 154.28,349.96
             154.26,348.20 154.25,346.44 154.24,344.69
             154.23,342.93 154.22,341.17 154.21,339.41
             154.20,337.66 156.14,336.43 156.84,334.13
             157.84,330.87 156.81,328.86 156.80,327.10
             156.79,325.34 158.10,321.82 158.09,320.06
             158.06,316.55 156.16,313.77 158.03,311.28
             158.97,310.03 159.35,309.51 159.34,307.76
             159.32,304.24 159.96,302.79 160.62,298.96
             160.92,297.25 160.60,295.45 160.59,293.69
             160.58,291.94 161.18,290.71 161.89,288.41
             162.89,285.16 159.96,282.12 161.83,279.63
             162.77,278.38 162.84,276.06 163.13,274.35
             163.79,270.52 165.77,269.06 165.76,267.30
             165.75,265.55 166.12,263.27 167.06,262.02
             168.93,259.53 168.74,256.23 169.68,254.98
             170.62,253.73 170.30,250.01 170.96,246.19
             171.25,244.47 171.59,242.98 172.25,239.15
             172.84,235.73 173.12,233.83 173.53,230.36
             174.17,224.87 176.14,221.56 176.12,218.04
             176.09,214.53 178.05,209.46 178.69,203.97
             179.10,200.50 180.65,197.06 181.26,188.14
             181.38,186.39 183.85,179.84 185.15,170.55
             186.12,163.64 184.67,159.88 186.36,151.21
             187.41,145.83 188.95,138.89 188.94,137.14
             188.91,131.87 188.87,126.60 188.84,121.33
             188.83,119.57 188.81,116.05 188.76,109.03
             188.75,107.27 191.39,101.98 191.36,98.47
             191.33,93.20 191.03,89.55 192.61,84.40
             193.73,80.77 195.85,77.89 196.55,75.59
             197.56,72.34 197.16,68.87 197.82,65.04
             198.12,63.33 200.92,60.27 203.10,56.23
             204.83,53.03 204.01,50.34 207.05,47.42
             209.45,45.10 210.26,44.90 212.35,42.11
             214.44,39.32 217.47,38.26 218.99,36.80
             221.39,34.48 224.73,36.17 228.30,33.22
             229.90,31.91 232.29,31.44 236.29,31.42
             238.96,31.40 241.63,31.38 244.30,31.37
             248.30,31.34 250.97,31.32 252.30,31.31
             254.97,31.30 256.30,31.29 258.97,31.27
             260.31,31.26 261.42,33.87 264.33,34.75
             265.63,35.15 267.01,36.49 269.69,38.23
             272.37,39.97 272.18,42.03 273.72,43.48
             276.16,45.76 278.58,48.85 279.10,50.47
             279.84,52.76 280.60,55.42 283.15,57.47
             284.29,58.39 286.48,58.90 287.19,62.72
             287.50,64.43 289.16,67.44 289.90,69.73
             291.46,74.59 289.94,76.76 291.31,82.02
             292.68,87.28 292.70,90.80 292.71,92.55
             292.73,96.07 292.78,103.09 292.80,106.61
             292.82,110.12 292.85,113.64 292.88,118.91
             292.89,120.66 292.91,124.18 292.95,129.45
             292.98,134.72 292.30,136.55 291.69,141.76
             291.05,147.24 288.74,151.96 287.77,154.08
             285.58,158.82 282.60,163.58 281.19,168.18
             280.69,169.80 278.27,173.14 275.91,177.00
             272.89,181.91 270.33,183.56 266.63,187.60
             263.74,190.77 262.67,192.89 260.02,196.42
             256.05,201.72 253.14,202.96 250.74,205.27
             249.22,206.73 243.88,207.83 241.45,212.36
             240.68,213.79 239.62,215.74 236.14,217.66
             233.69,219.02 232.11,219.04 230.82,219.45
             227.92,220.37 227.24,222.04 225.51,223.00
             223.05,224.36 221.92,223.83 220.18,224.79
             217.72,226.15 214.53,222.81 210.84,224.85
             209.11,225.81 206.85,226.63 202.85,226.66
             201.52,226.67 198.85,226.68 197.51,226.69
             194.85,226.71 193.51,226.72 192.18,226.72
             190.84,226.73 189.00,226.61 189.50,224.98
             190.21,222.68 192.16,223.21 193.49,223.20
             194.82,223.19 197.49,223.18 200.16,223.16
             202.83,223.14 205.58,222.91 208.18,224.87
             212.36,228.02 213.22,229.08 217.56,231.83
             221.36,234.25 224.18,235.83 225.61,238.81
             227.20,242.14 230.98,244.05 233.67,247.55
             235.01,249.29 236.37,252.80 237.72,256.30
             239.08,259.81 239.64,261.14 241.79,266.82
             243.68,271.80 243.17,273.84 244.54,279.10
             245.91,284.36 248.30,289.67 248.62,291.38
             250.04,299.01 251.33,304.38 254.08,310.67
             255.02,312.82 256.64,319.55 258.16,322.94
             260.61,328.40 261.43,330.68 263.56,333.45
             265.69,336.21 267.10,340.59 267.62,342.21
             269.09,346.79 273.08,346.77 274.32,347.44
             277.82,349.32 279.92,350.37 282.36,352.66
             283.90,354.10 286.37,354.39 289.04,354.37
             291.71,354.35 293.04,354.35 295.71,354.33
             298.38,354.31 301.04,354.29 302.38,354.29
             306.38,354.26 310.63,354.77 313.04,352.46
             314.56,351.00 318.35,348.91 321.00,345.38
             322.32,343.62 326.78,342.35 328.96,338.30
             330.68,335.11 331.82,333.27 332.91,331.25
             334.64,328.05 336.14,322.98 336.85,320.68
             338.35,315.80 337.21,311.76 338.09,306.62
             338.75,302.79 339.37,297.83 339.34,292.56
             339.30,287.29 339.29,285.53 339.26,280.26
             339.23,274.99 339.20,271.47 339.17,266.20
             339.14,260.93 339.09,253.90 339.07,250.39
             339.03,243.36 338.98,236.33 338.93,227.55
             338.90,224.04 339.27,216.86 340.16,211.73
             341.48,204.07 342.08,200.76 345.37,192.37
             347.58,186.75 351.33,181.22 353.29,178.26
             356.44,173.49 362.28,172.40 363.91,171.17
             368.68,167.57 371.89,167.60 377.23,167.57
             378.56,167.56 382.56,165.78 383.89,165.77
             387.89,165.74 389.22,165.73 390.56,165.73
             391.89,165.72 393.23,165.71 394.56,165.70
             395.89,165.69 396.29,166.20 397.24,167.44
             398.19,168.68 398.60,170.95 398.61,172.70
             398.62,174.46 399.66,176.26 399.97,177.97
             400.68,181.78 401.34,183.23 401.35,184.98
             401.36,186.74 400.05,190.26 401.39,190.26
             402.72,190.25 401.36,186.74 400.02,184.99
             398.67,183.24 397.33,181.50 395.98,179.75
             394.64,178.00 393.71,177.20 391.96,176.26
             389.49,174.93 386.52,175.21 385.28,174.54
             383.53,173.60 382.60,172.80 379.93,172.82
             378.60,172.83 375.93,172.85 373.26,172.86
             370.59,172.88 368.85,171.04 366.59,172.91
             364.07,174.99 363.73,177.94 362.63,179.96
             360.91,183.16 360.01,187.00 358.70,190.53
             357.39,194.05 356.96,198.11 354.78,202.85
             353.80,204.97 352.01,211.59 350.86,216.93
             349.37,223.90 348.30,226.87 346.97,234.53
             345.79,241.37 345.07,248.38 344.43,253.87
             343.62,260.81 344.52,267.93 344.56,274.95
             344.60,280.22 344.63,285.49 344.66,290.77
             344.71,297.79 344.52,299.62 346.10,306.57
             347.31,311.90 348.39,315.39 348.84,318.85
             349.55,324.33 351.76,326.69 352.90,327.61
             355.45,329.66 355.85,332.32 358.28,334.60
             359.82,336.05 362.08,338.95 364.98,339.83
             367.59,340.62 369.06,340.76 371.67,341.55
             374.57,342.43 375.68,343.28 377.01,343.27
             379.68,343.25 381.01,343.24 383.68,343.23
             386.35,343.21 388.18,339.83 391.65,337.91
             392.88,337.23 395.64,336.12 398.30,334.35
             400.96,332.58 402.28,330.81 403.60,329.05
             406.25,325.51 407.76,322.91 408.89,321.98
             411.42,319.90 412.43,312.85 414.15,309.65
             415.24,307.63 416.36,302.28 418.09,299.08
             419.18,297.06 421.05,292.39 422.03,290.27
             424.22,285.53 423.87,281.33 424.62,277.96
             425.98,271.89 427.94,267.30 428.53,263.88
             429.20,260.05 430.49,258.90 431.15,255.08
             431.44,253.36 432.45,249.80 432.42,246.28
             432.41,244.53 432.38,239.25 432.36,235.74
             432.34,232.23 432.32,230.47 432.30,226.96
             432.29,225.20 432.27,221.69 432.26,219.93
             432.25,218.17 431.99,214.92 430.88,212.91
             429.11,209.73 428.47,205.85 428.15,204.14
             427.45,200.32 426.85,198.35 425.43,195.37
             423.84,192.04 422.74,191.88 421.40,190.13
             420.05,188.38 418.31,186.12 417.36,184.88
             416.41,183.65 415.62,182.62 414.67,181.39
             413.72,180.15 411.61,180.89 410.66,179.65
             409.71,178.42 409.31,177.91 407.97,176.16
             406.62,174.41 406.23,173.90 405.28,172.66
             404.33,171.42 402.61,172.68 401.27,172.69
             399.94,172.69 397.26,170.95 397.27,172.71
             397.28,174.47 399.94,172.69 401.27,172.69
             402.61,172.68 403.94,172.67 405.28,172.66
             406.61,172.65 407.94,172.64 409.28,172.64
             410.61,172.63 411.96,174.38 413.29,174.37
             414.63,174.36 415.96,174.35 417.29,174.34
             418.63,174.33 419.96,174.32 421.30,174.32
             422.63,174.31 423.96,174.30 425.30,174.29
             426.63,174.28 427.97,174.27 429.30,174.27
             430.63,174.26 433.30,174.24 434.64,174.23
             435.97,174.22 437.30,174.21 438.64,174.21
             439.97,174.20 439.96,172.44 441.29,172.43
             442.63,172.42 444.07,173.09 445.30,172.41
             447.03,171.44 447.95,170.63 449.29,170.62
             450.62,170.62 452.06,171.28 453.29,170.60
             455.03,169.64 455.52,166.26 457.26,165.30
             458.48,164.62 460.13,164.87 462.58,163.51
             464.32,162.55 465.23,159.98 466.55,158.22
             467.87,156.45 469.20,154.68 470.52,152.92
             471.84,151.15 473.15,147.63 474.46,144.11
             475.78,140.59 476.42,139.14 477.08,135.31
             477.37,133.60 477.67,132.33 478.38,130.03
             479.38,126.78 480.29,125.28 481.00,122.98
             482.00,119.73 481.79,117.57 482.29,115.95
             483.00,113.65 483.29,112.38 483.59,110.67
             484.25,106.84 486.22,105.38 486.20,101.87
             486.18,98.35 487.07,96.54 487.48,93.07
             488.12,87.58 488.77,86.04 488.75,82.52
             488.72,79.01 490.03,73.73 490.01,71.97
             489.99,68.46 489.96,63.19 489.95,61.43
             489.94,59.67 489.91,56.16 489.90,54.40
             489.89,52.65 490.82,50.37 489.87,49.13
             488.92,47.90 487.92,47.93 487.18,45.64
             486.66,44.02 485.83,43.89 484.50,43.90
             483.17,43.90 482.34,44.04 481.84,45.67
             481.14,47.97 480.13,47.95 479.20,49.20
             477.33,51.70 477.28,53.94 476.57,56.24
             476.07,57.87 475.27,61.52 475.28,63.28
             475.30,65.04 475.31,66.80 474.00,70.32
             472.68,73.84 472.69,75.60 472.72,79.11
             472.74,82.62 471.73,86.19 471.44,87.90
             470.78,91.73 470.15,94.94 470.17,98.45
             470.19,101.97 470.22,105.48 470.25,110.75
             470.26,112.51 470.28,116.02 470.31,119.54
             470.33,123.05 470.34,124.81 470.37,130.08
             470.40,133.59 470.80,137.18 470.43,138.86
             469.07,144.94 467.83,149.42 467.84,151.18
             467.87,156.45 467.89,159.96 467.93,165.23
             467.94,166.99 467.97,172.26 468.00,175.78
             468.03,181.05 467.38,182.59 466.74,188.08
             466.13,193.29 467.02,198.65 466.82,200.38
             466.18,205.87 464.88,208.97 464.24,214.45
             464.04,216.19 463.63,221.18 462.97,225.00
             462.38,228.43 463.01,230.28 463.04,235.55
             463.07,240.82 463.08,242.57 463.11,246.09
             463.14,251.36 463.17,256.63 463.18,258.39
             463.21,261.90 463.23,265.41 463.25,268.93
             463.26,270.68 463.28,274.20 463.31,277.71
             463.33,281.23 463.34,282.98 463.36,286.50
             463.37,288.25 463.38,290.01 463.41,293.52
             463.43,297.04 463.44,298.80 463.45,300.55
             463.47,304.07 463.50,307.58 463.52,311.09
             463.53,312.85 463.54,314.61 463.56,318.12
             463.57,319.88 463.59,321.64 463.61,325.15
             463.62,326.91 463.64,330.42 463.65,332.18
             463.66,333.93 465.63,336.90 466.37,339.19
             466.89,340.81 466.78,343.21 467.73,344.45
             468.68,345.69 469.27,344.85 471.75,346.18
             473.49,347.12 473.87,347.20 475.77,349.67
             476.72,350.91 476.18,351.94 477.13,353.18
             478.08,354.41 478.85,353.68 479.81,354.92
             480.76,356.15 482.47,354.90 483.81,354.89
             485.14,354.88 486.48,354.87 487.81,354.87
             489.14,354.86 490.48,354.85 491.81,354.84
             493.14,354.83 494.48,354.82 495.81,354.81
             498.48,354.80 499.92,355.46 501.15,354.78
             502.89,353.82 503.79,351.25 506.46,351.23
             507.80,351.22 510.05,350.40 511.79,349.44
             513.02,348.76 514.04,348.62 515.78,347.66
             517.01,346.98 516.90,345.59 518.42,344.13
             520.83,341.82 522.67,342.88 525.07,340.57
             526.59,339.11 528.64,336.23 530.37,335.27
             531.60,334.59 531.80,334.17 533.03,333.49
             534.77,332.53 535.16,329.83 535.66,328.21
             536.37,325.91 536.98,324.68 538.29,321.16
             539.60,317.64 539.91,317.37 540.91,314.12
             541.62,311.82 542.87,310.90 543.53,307.07
             543.83,305.36 543.00,303.43 543.50,301.80
             544.21,299.50 545.43,298.81 546.13,296.51
             546.64,294.89 547.45,292.99 547.44,291.23
             547.41,287.72 547.40,285.96 547.39,284.21
             547.38,282.45 547.37,280.69 547.36,278.94
             547.35,277.18 547.33,275.42 547.32,273.66
             547.31,271.91 547.30,270.15 547.29,268.39
             547.27,264.88 546.61,263.44 545.90,259.62
             545.58,257.91 544.54,256.11 544.53,254.36
             544.52,252.60 544.13,252.09 543.18,250.85
             541.27,248.38 542.05,247.17 540.46,243.84
             539.75,242.35 539.62,240.20 539.10,238.58
             538.36,236.29 536.83,236.51 535.06,233.33
             533.95,231.32 532.37,229.83 531.03,228.09
             529.68,226.34 528.57,223.73 525.66,222.85
             524.36,222.45 524.31,221.10 522.97,219.35
             521.62,217.60 518.94,215.86 517.60,214.12
             516.25,212.37 514.54,213.62 513.58,212.38
             512.63,211.15 512.64,209.83 510.89,208.89
             509.66,208.22 508.63,208.10 506.88,207.16
             505.64,206.49 504.21,207.17 502.88,207.18
             501.54,207.19 500.20,205.44 498.87,205.45
             497.53,205.46 496.20,205.47 494.86,205.47
             493.53,205.48 490.85,203.74 489.52,203.75
             488.18,203.76 486.85,203.77 485.52,203.78
             484.18,203.79 482.85,203.79 481.51,203.80
             480.18,203.81 478.45,202.58 477.51,203.83
             476.58,205.08 476.19,205.59 476.20,207.35
             476.21,209.11 475.28,211.38 476.23,212.62
             477.18,213.86 477.68,213.70 478.91,214.36
             480.66,215.30 480.65,216.62 481.60,217.86
             483.50,220.33 485.20,218.64 486.95,219.58
             488.19,220.25 489.71,218.89 490.95,219.56
             492.70,220.50 493.63,221.30 494.96,221.29
             496.30,221.28 497.64,223.03 498.98,223.02
             500.31,223.01 501.65,223.00 502.98,222.99
             504.31,222.98 505.65,222.98 506.98,222.97
             508.32,222.96 509.65,222.95 510.98,222.94
             512.32,222.93 513.65,222.93 514.98,222.92
             516.32,222.91 517.65,222.90 518.99,222.89
             520.32,222.88 521.65,222.87 522.99,222.87
             524.32,222.86 525.66,222.85 526.99,222.84
             528.32,222.83 529.66,222.82 530.99,222.82
             532.33,222.81 534.06,224.04 534.99,222.79
             535.93,221.54 536.42,221.70 537.65,221.02
             539.39,220.05 540.70,218.72 541.63,217.48
             542.57,216.23 544.09,215.40 545.61,213.94
             548.02,211.62 549.60,212.15 550.92,210.39
             552.25,208.62 553.68,207.53 554.90,206.85
             556.64,205.89 558.18,205.61 558.88,203.31
             559.38,201.68 560.19,199.79 562.84,196.26
             564.16,194.49 565.07,192.40 566.80,189.20
             567.89,187.18 568.51,186.92 569.44,185.67
             570.38,184.43 569.42,182.16 570.75,182.15
             570.75,182.15 570.74,180.39 570.74,180.39
             570.74,180.39 572.07,178.63 572.07,178.63
             572.07,178.63 572.05,176.87 572.05,176.87'
      />
    </svg>
  );
}

export default Signature;
